import { useRecoveryChangeMutation } from '@/shared/api-rtk'
import { PasswordInput } from '@/shared/components/PasswordInput/ui/PasswordInput'
import { TOAST_ERROR, TOAST_SUCCESS } from '@/shared/constants/toastTypes'
import { useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { redirect, useParams } from 'next/navigation'
import styles from './styles.module.css'

export const FormPasswordChange = ({ backData }) => {
    const [fetch, { isLoading, isError, isSuccess, data }] =
        useRecoveryChangeMutation()

    const [password, setPassword] = useState('')
    const [passwordIsInvalid, setPasswordIsinvalid] = useState(false)
    const [retry, setRetry] = useState('')
    const [retryIsinvalid, setRetryIsinvalid] = useState(false)
    const changePassword = (val) => setPassword(val)
    const changeRetry = (val) => setRetry(val)

    const navigate = (url) => redirect(url)

    const sendHandler = async (e) => {
        e.preventDefault()
        if (passwordIsInvalid || retryIsinvalid) return
        // console.log({ password, retry, backData })
        const response = await fetch({ password, retry, token: backData.code }).unwrap()
        if (response.success) {
            TOAST_SUCCESS('Пароль успешно изменен!')
            navigate('/login')
        } else {
            TOAST_ERROR(response.error)
        }
    }

    const passBlurHandler = (e) => {
        if (e.target.value.length < 4 || e.target.value.length > 20) {
            setPasswordIsinvalid(true)
        } else {
            setPasswordIsinvalid(false)
        }
    }

    const passFocusHandler = (e) => {
        setPasswordIsinvalid(false)
    }

    const retryBlurHandler = (e) => {
        setRetryIsinvalid(e.target.value !== password)
    }

    const retryFocusHandler = (e) => {
        setRetryIsinvalid(false)
    }

    return (
        <Form
            className={styles.form}
            onSubmit={sendHandler}
            style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}
        >
            <PasswordInput
                label={'Введите пароль'}
                value={password}
                onChange={(e) => changePassword(e.target.value)}
                onBlur={passBlurHandler}
                feedbackMessage={
                    'пароль не может быть короче 4 и длинее 20 символов'
                }
                isInvalid={passwordIsInvalid}
                onFocus={passFocusHandler}
            />

            <PasswordInput
                label={'Повторите пароль'}
                value={retry}
                onChange={(e) => changeRetry(e.target.value)}
                onBlur={retryBlurHandler}
                onFocus={retryFocusHandler}
                feedbackMessage={'Пароли не совпадают'}
                isInvalid={retryIsinvalid}
            />

            <Button type="subbmit">Подтвердить</Button>
        </Form>
    )
}
